<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Tip from "@/components/_base/Tip";

import dateMixin from "@/mixins/dateMixin";

import Filters from "./Filters";
import CancelOrderOffer from "../ProfessionalOfferList/CancelOrderOffer";

export default {
  mixins: [dateMixin],

  components: {
    Filters,
    CancelOrderOffer,
    Tip
  },

  data() {
    return {
      open: false
    };
  },

  methods: {
    ...mapActions("orderScheduler", [
      "requestProfessionalsAvailable",
      "cancelOrderOffer"
    ]),

    toogleFilter() {
      if (
        this.orderOfferEnable &&
        this.orderOfferExpired &&
        !this.avaliableProfessionals.length
      ) {
        this.handleCancelOrderOffer();
      }

      this.open = !this.open;
    },

    handleProfessionalSearch() {
      this.toogleFilter();

      this.requestProfessionalsAvailable(true);
    },

    handleCancelOrderOffer() {
      this.cancelOrderOffer();
    }
  },

  computed: {
    ...mapState("orderScheduler", [, "orderOfferEnable", "orderOfferExpired"]),

    ...mapGetters("orderScheduler", [
      "date",
      "initialHour",
      "duration",
      "professionalName",
      "missingRequiredFields",
      "searchOrderOfferProfessionals",
      "avaliableProfessionals"
    ]),

    dateSelection: function() {
      return !this.date ? "Quando?" : this.convertDateObject(this.date);
    },

    initialHourSelection: function() {
      return !this.initialHour
        ? "Começar às?"
        : (this.initialHour < 10 ? "às 0" : "às ") + `${this.initialHour}:00`;
    },

    durationSelection: function() {
      return !this.duration
        ? "Horas?"
        : `${this.duration} hora` + (this.duration > 1 ? "s" : "");
    },

    professionalNameSelection: function() {
      return !this.professionalName
        ? "Quem você está procurando?"
        : this.professionalName;
    },

    noFilterSelected: function() {
      return (
        !this.date &&
        !this.initialHour &&
        !this.duration &&
        !this.professionalName
      );
    }
  }
};
</script>

<template>
  <div class="root-filters" :class="{ pulse: noFilterSelected }">
    <div class="dtd-filters" @click="toogleFilter">
      <div class="date">
        <span class="header" :class="{ 'header-inverted': date }">
          Dia
        </span>

        <span class="detail" :class="{ 'detail-inverted': date }">
          {{ dateSelection }}
        </span>
      </div>

      <div class="time">
        <span class="header" :class="{ 'header-inverted': initialHour }">
          Hora inicial
        </span>

        <span class="detail" :class="{ 'detail-inverted': initialHour }">
          {{ initialHourSelection }}
        </span>
      </div>

      <div class="duration">
        <span class="header" :class="{ 'header-inverted': duration }">
          Duração
        </span>

        <span class="detail" :class="{ 'detail-inverted': duration }">
          {{ durationSelection }}
        </span>
      </div>
    </div>

    <div class="name-filter" @click="toogleFilter">
      <div class="name">
        <span class="header" :class="{ 'header-inverted': professionalName }">
          Nome do Profissional
        </span>

        <span class="detail" :class="{ 'detail-inverted': professionalName }">
          {{ professionalNameSelection }}
        </span>
      </div>
    </div>

    <div class="filter-tip">
      <Tip type="info" size="small">Edite acima os filtros de dia, hora e duração.</Tip>
    </div>

    <CancelOrderOffer v-if="open && searchOrderOfferProfessionals" @closeCancelOrderOfferModal="toogleFilter" @cancelOrderOffer="handleCancelOrderOffer" />

    <Filters v-else-if="open" @endFilterEdition="toogleFilter" @search="handleProfessionalSearch" />
  </div>
</template>

<style scoped>
.root-filters {
  width: calc(100% - 24px);
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  position: relative;
  background: #fff;
  user-select: none;
  cursor: pointer;
  margin-bottom: 24px;
}

.root-filters.pulse {
  animation: pulse 2s infinite;
}

.dtd-filters {
  width: 100%;
  display: flex;
  cursor: pointer;
  user-select: none;
}

.date,
.time,
.duration {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
}

.date,
.duration {
  width: 32%;
}

.time {
  width: 36%;
  border-left: solid 1px #e2e2e2;
  border-right: solid 1px #e2e2e2;
}

.header {
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #424242;
  transition: color 0.25s ease-in-out;
}

.header-inverted {
  color: #666;
  font-weight: 300;
}

.detail {
  font-size: 13px;
  color: #666;
  transition: color 0.25s ease-in-out;
}

.detail-inverted {
  color: #424242;
  font-weight: 400;
}

.name-filter {
  width: 100%;
  margin-top: 8px;
  padding-top: 8px;
  border-top: solid 1px #e2e2e2;
}

.name {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.filter-tip {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -20px;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0.4);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 10px rgba(175, 0, 107, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
    box-shadow: 0 0 0 0 rgba(175, 0, 107, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Filters/Index.vue